<template>
  <div class="delivery-cell">
    <template v-if="isEditMode">
      <el-input
        v-if="item.key === 'doDeliveryNo'"
        v-model="localValue[item.key]"
        size="normal"
        style="width: 100%"
        maxlength="15"
      />
      <!-- PB-1418の対応で、以下のspanを追加する。 -->
      <!-- 詳細はmixinTsValidation.jsに記載の【PB-1418 doDeliveryNo1のtsValidation追加対応】参照。 -->
      <span v-if="item.key === 'doDeliveryNo' && tsValidationDisplayMessage.doDeliveryNo1 && rowIndex === 0"
        class="do-delivery-order-no-1-span has_error">
        <p>{{ tsValidationDisplayMessage.doDeliveryNo1 }}</p>
      </span>

      <el-input
        v-else-if="item.key === 'doPlaceName' || item.key === 'doRemarks'"
        type="textarea"
        v-model="localValue[item.key]"
        size="normal"
        style="width: 100%; max-height: 3.6em;"
        show-word-limit
        :maxlength="100"
      />
      <el-select
        ref="containerTypeSelect"
        v-else-if="item.key === 'doContainerType'"
        v-model="containerTypeModel"
        placeholder="Select or Input"
        filterable
        :allow-create="true"
        :default-first-option="false"
        clearable
        size="mini"
        style="width: 100%"
        @blur="onSelectBlur"
        @keydown.native.enter.prevent="handleKeyDown"
      >
        <el-option
          v-for="type in SYS_MST_CONTAINER_TYPE"
          :key="type.code"
          :label="type.description"
          :value="type.code"
        />
      </el-select>
      <el-date-picker
        v-else-if="item.key === 'doScheduledDatetime'"
        v-model="localValue[item.key]"
        type="datetime"
        size="small"
        placeholder="Select Date Time"
        style="width: 100%"
        format="yyyy-MM-dd HH:mm"
      />
      <el-date-picker
        v-else-if="item.key === 'doCyPickupDate' || item.key === 'doActualDate'"
        v-model="localValue[item.key]"
        type="date"
        size="small"
        placeholder="Select Date"
        style="width: 100%"
        value-format="yyyy-MM-dd"
        format="yyyy-MM-dd"
      />
      <el-checkbox
        v-else-if="item.key === 'doOltFlag' || item.key === 'doArranged'"
        v-model="localValue[item.key]"
        :true-label="1"
        :false-label="0"
        class="delivery_checkbox"
        style="width: 100%"
      />
      <el-radio-group
        v-else-if="item.key === 'doUndisclosedFlag'"
        class="delivery_radio"
        v-model="localValue[item.key]"
        size="mini"
      >
        <el-radio-button :label="UNDISCLOSED_FLAG.OFF">Shared</el-radio-button>
        <el-radio-button :label="UNDISCLOSED_FLAG.ON">Not Shared</el-radio-button>
      </el-radio-group>
    </template>

    <template v-else>
      <span v-if="item.key === 'doDeliveryNo' || item.key === 'doPlaceName' || item.key === 'doRemarks' || item.key === 'doCyPickupDate' || item.key === 'doActualDate'" class="delivery_readonly_text">
        {{ formatDisplay(localValue[item.key]) }}
      </span>
      <span v-if="item.key === 'doScheduledDatetime'" class="delivery_readonly_text">
        {{ formatDateTime(localValue[item.key]) }}
      </span>
      <span v-else-if="item.key === 'doContainerType'" class="delivery_readonly_text">
        {{ formatContainerTypeDescription(localValue) }}
      </span>
      <span v-else-if="item.key === 'doOltFlag'" class="delivery_readonly_checkbox">
        {{ localValue[item.key] === OLT_FLAG.ON ? '✔' : '' }}
      </span>
      <span v-else-if="item.key === 'doArranged'" class="delivery_readonly_checkbox">
        {{ localValue[item.key] === ARRANGED.ON ? '✔' : '' }}
      </span>
      <span v-else-if="item.key === 'doUndisclosedFlag'" class="delivery_readonly_text">
        {{ formatUndisclosedFlag(localValue[item.key]) }}
      </span>
    </template>
  </div>
</template>

<script>
import { UNDISCLOSED_FLAG, OLT_FLAG, ARRANGED } from 'lib-tw-common';

export default {
  name: 'TwProcessGroupListEditDeliveryTableItem',
  inject: ['tsValidationDisplayMessage'],
  props: {
    item: Object,
    value: Object,
    isEditMode: Boolean,
    rowIndex: Number,
  },
  data() {
    return {
      UNDISCLOSED_FLAG: UNDISCLOSED_FLAG,
      OLT_FLAG: OLT_FLAG,
      ARRANGED: ARRANGED
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    SYS_MST_CONTAINER_TYPE() {
      return this.$store.getters.getSysMstContainerType;
    },
    containerTypeModel: {
      get() {
        const { doContainerSize, doContainerType, doUnitType } = this.localValue;

        if (doContainerSize && doContainerType) {
          return `${doContainerSize}${doContainerType}`;
        } else if (doUnitType) {
          return doUnitType;
        } else {
          return '';
        }
      },
      set(value) {
        const containerType = this.SYS_MST_CONTAINER_TYPE.find(item => item.code === value || item.description === value);

        if (containerType) {
          this.$emit('input', {
            ...this.localValue,
            doContainerType: containerType.type || '',
            doContainerSize: containerType.size || '',
            doUnitType: ''
          });
        } else {
          const trimmed = value.substring(0, 30);
          this.$emit('input', {
            ...this.localValue,
            doContainerType: '',
            doContainerSize: '',
            doUnitType: trimmed
          });
        }
      }
    }
  },
  watch: {
    'localValue.doScheduledDatetime': {
      immediate:true,
      handler(val) {
        if (val && !(val instanceof Date)) {
          const parsed = new Date(val);
          if (!isNaN(parsed)) {
            this.localValue = {
              ...this.localValue,
              doScheduledDatetime: parsed
            };
          }
        }
      }
    }
  },
  methods: {
    onSelectBlur() {
      const input = this.$el.querySelector('.el-input__inner');
      const textType = input ? input.value.trim() : '';

      if (textType && textType !== this.containerTypeModel) {
        this.containerTypeModel = textType;
      }
    },
    containerTypeLabel() {
      const selected = this.SYS_MST_CONTAINER_TYPE.find(opt => opt.code === this.containerTypeModel);
      return selected?.description || this.containerTypeModel;
    },
    formatDateTime(val) {
      if (!val) return '';
      const dateTime = new Date(val);
      if (isNaN(dateTime)) return '';
      const year = dateTime.getFullYear();
      const month = String(dateTime.getMonth() + 1).padStart(2, '0');
      const date = String(dateTime.getDate()).padStart(2, '0');
      const hours = String(dateTime.getHours()).padStart(2, '0');
      const minutes = String(dateTime.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${date} ${hours}:${minutes}`;
    },
    formatDisplay(val) {
      return val === null || val === '' ? '' : val;
    },
    formatUndisclosedFlag(val) {
      if (val === null || val === '') return '';
      return val === this.UNDISCLOSED_FLAG.ON ? 'Not Shared' : 'Shared';
    },
    formatContainerTypeDescription(val) {
      const { doContainerSize, doContainerType, doUnitType } = val;

      if (doContainerSize && doContainerType) {
        const code = `${doContainerSize}${doContainerType}`;
        const found = this.SYS_MST_CONTAINER_TYPE.find(type => type.code === code);
        return found?.description || '';
      }
      if (doUnitType) {
        return doUnitType
      }
      return '';
    },
    handleKeyDown() {
      this.onSelectBlur();
      if (this.$refs.containerTypeSelect) {
        this.$refs.containerTypeSelect.blur();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
  .delivery-cell {
    width: 100%;
    .delivery_checkbox, .delivery_radio {
        align-items: center;
        justify-content: center;
        display: flex;
    }
  }
  .delivery_readonly_checkbox {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .delivery_readonly_text {
    display: block;
    white-space: normal;
    word-break: break-word;
    max-height: 3.6em;
    overflow-y: auto;
    text-align: left;
    padding-left: 10px;
    color: #111;
  }
  .do-delivery-order-no-1-span.has_error {
    color: $color_warning;
    font-size: 12px;
    line-height: 1;
  }
</style>
